import { Extension, NodeSelection, TextSelection } from 'tiptap'

export default class replaceWithNode extends Extension {
   get name() {
      return 'replaceWithNode'
   }

   get defaultOptions() {
      return {
         node: 'paragraph',
         notAfter: ['paragraph'],
      }
   }

   commands() {
      return () => (state, dispatch) => {
         // https://discuss.prosemirror.net/t/how-to-select-a-node-immediately-after-inserting-it/1566
         // https://discuss.prosemirror.net/t/cannot-read-property-istextblock-of-undefined-when-focusing-empty-paragraph/1025/4

         const { doc, schema, tr } = state

         const type = schema.nodes[this.options.node]
         const position = doc.content.size // end of document
         const node = type.create()

         const transaction = tr.insert(position, node)

         const resolvedPos = transaction.doc.resolve(transaction.doc.content.size)
         transaction
            .setSelection(new NodeSelection(transaction.doc.resolve(resolvedPos.pos - 2)))
            .setSelection(new TextSelection(transaction.doc.resolve(resolvedPos.pos - 1)))

         dispatch(transaction)
      }
   }
}
